var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarHourIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4.25H6C3.93 4.25 2.25 5.93 2.25 8V16C2.25 18.07 3.93 19.75 6 19.75H18C20.07 19.75 21.75 18.07 21.75 16V8C21.75 5.93 20.07 4.25 18 4.25ZM20.25 16C20.25 17.24 19.24 18.25 18 18.25H6C4.76 18.25 3.75 17.24 3.75 16V8C3.75 6.76 4.76 5.75 6 5.75H18C19.24 5.75 20.25 6.76 20.25 8V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.75H10C10.41 9.75 10.75 9.41 10.75 9C10.75 8.59 10.41 8.25 10 8.25H8.75V8C8.75 7.59 8.41 7.25 8 7.25C7.59 7.25 7.25 7.59 7.25 8V8.28C6.13 8.41 5.25 9.35 5.25 10.5C5.25 11.74 6.26 12.75 7.5 12.75H8.5C8.91 12.75 9.25 13.09 9.25 13.5C9.25 13.91 8.91 14.25 8.5 14.25H6C5.59 14.25 5.25 14.59 5.25 15C5.25 15.41 5.59 15.75 6 15.75H7.25V16C7.25 16.41 7.59 16.75 8 16.75C8.41 16.75 8.75 16.41 8.75 16V15.72C9.87 15.59 10.75 14.65 10.75 13.5C10.75 12.26 9.74 11.25 8.5 11.25H7.5C7.09 11.25 6.75 10.91 6.75 10.5C6.75 10.09 7.09 9.75 7.5 9.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9.25H13C12.59 9.25 12.25 9.59 12.25 10C12.25 10.41 12.59 10.75 13 10.75H18C18.41 10.75 18.75 10.41 18.75 10C18.75 9.59 18.41 9.25 18 9.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.25H16C15.59 13.25 15.25 13.59 15.25 14C15.25 14.41 15.59 14.75 16 14.75H18C18.41 14.75 18.75 14.41 18.75 14C18.75 13.59 18.41 13.25 18 13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarHourIcon);
export default __webpack_public_path__ + "static/media/dollar_hour_icon.112e357231c1ba78a26825d048bb38cb.svg";
export { ForwardRef as ReactComponent };